export default {
  colors: "couleur",
  families: "région",
  years: "millésime",
  "min_price": "prix minimum",
  "max_price": "prix maximum",
  capacity: "format",
  only_bio: "bio"
};
